/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */

import React from 'react';
import {HISTORY_EVENT_ICON_BY_ASSET} from '../maps/constants';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Iginition Off Icon component.
 */
export const IgnitionOffIcon = (props: IconProps) => {
  const {iconSize} = useIconDLS(props);
  const {ignOff}   = HISTORY_EVENT_ICON_BY_ASSET;

  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path transform='rotate(-180 8 8)' fill={ignOff.color} d='M0 8a8 8 0 1 0 16 0a8 8 0 1 0 -16 0' />
    </svg>
  );
};
